var _rect, _rect2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGiftBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "url(#paint0_linear_407_690)",
    fillOpacity: 0.12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.56006,
    y: 7.56006,
    width: 38.88,
    height: 38.88,
    rx: 19.44,
    fill: "url(#paint1_linear_407_690)",
    fillOpacity: 0.82
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1652 35.5354C19.1652 35.9488 19.4991 36.2827 19.9125 36.2827H26.5917V27.5017H19.1652V35.5354ZM28.1797 36.2827H34.8589C35.2723 36.2827 35.6062 35.9488 35.6062 35.5354V27.5017H28.1797V36.2827ZM35.9799 21.8968H32.5329C32.8505 21.397 33.0373 20.8038 33.0373 20.1686C33.0373 18.3914 31.5917 16.9458 29.8145 16.9458C28.8477 16.9458 27.9766 17.3755 27.3857 18.0528C26.7949 17.3755 25.9238 16.9458 24.9569 16.9458C23.1797 16.9458 21.7341 18.3914 21.7341 20.1686C21.7341 20.8038 21.9186 21.397 22.2385 21.8968H18.7915C18.3781 21.8968 18.0442 22.2308 18.0442 22.6441V25.9137H26.5917V21.8968H28.1797V25.9137H36.7272V22.6441C36.7272 22.2308 36.3933 21.8968 35.9799 21.8968ZM26.5917 21.8034H24.9569C24.0555 21.8034 23.3221 21.0701 23.3221 20.1686C23.3221 19.2672 24.0555 18.5339 24.9569 18.5339C25.8584 18.5339 26.5917 19.2672 26.5917 20.1686V21.8034ZM29.8145 21.8034H28.1797V20.1686C28.1797 19.2672 28.913 18.5339 29.8145 18.5339C30.716 18.5339 31.4493 19.2672 31.4493 20.1686C31.4493 21.0701 30.716 21.8034 29.8145 21.8034Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_407_690",
    x1: 8.48571,
    y1: -1.78011e-7,
    x2: 54,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C9EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5869FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_407_690",
    x1: 13.6698,
    y1: 7.56006,
    x2: 46.4401,
    y2: 46.4401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C9EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5869FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftBox);
export default __webpack_public_path__ + "static/media/gift-box.e0d3c3259dc9295d8560bc8cbdb7e93c.svg";
export { ForwardRef as ReactComponent };